import CourseSelectionMenu from './menu-queries/course-selection-menu'
import ThreedmssCourseMenu from './menu-queries/threedmss-course-menu'

//Maps Course Menu components (found in menu-queries) to String keys so that they can be dynamically rendered using String formatting
const courseMappings = {
  "CourseselectionCourseMenu": CourseSelectionMenu,
  "ThreedmssCourseMenu": ThreedmssCourseMenu
}

export default courseMappings